import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IReplyLineIconProps extends IConDefaultType {}

export default function ReplyLineIcon({ color = '#E0E0E0', className, size = 24, rotate, flip }: IReplyLineIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.875 2C3.35825 2 3.75 2.39175 3.75 2.875V8.25C3.75 8.80228 4.19772 9.25 4.75 9.25H10.125C10.6082 9.25 11 9.64175 11 10.125C11 10.6082 10.6082 11 10.125 11H4C2.89543 11 2 10.1046 2 9V2.875C2 2.39175 2.39175 2 2.875 2Z"
          fill={color}
        />
      </svg>
    </i>
  );
}
